import { Login } from "./Login";

export const LoginPage = () => {
  return <Login />;
};